module.exports = __webpack_public_path__ + "documents/cb905e5152c733037d832e186096daf8.csv";